'use client';

import type { FundingModel } from '@bytel/leviator';
import {
    DirectionEnum,
    FlexBox,
    FlexItem,
    IconName,
    RadioTile,
    Tag,
    TagVariant,
    Text,
    TextLevels,
} from '@bytel/trilogy-react';

import { FundingDetailsBox } from '@components/funding-details-box';
import { InlinePrice } from '@components/inline-price';

import { OdrInfos } from './odr-infos';

export interface FundingInstallmentItemProps {
    funding: FundingModel;
    isSelected: boolean;
    onSelect: () => void;
    hasOdr: boolean;
    odrRefund: number;
    phonePriceWithOdrDeducted: number;
}

export function FundingInstallmentItem({
    funding,
    isSelected,
    onSelect,
    hasOdr,
    odrRefund,
    phonePriceWithOdrDeducted,
}: Readonly<FundingInstallmentItemProps>) {
    const hasInterest = funding.interestAmount > 0;

    return (
        <FlexItem>
            <FlexBox direction={DirectionEnum.COLUMN} gap={1}>
                <RadioTile
                    id={funding.key}
                    horizontal
                    checked={isSelected}
                    onChange={onSelect}
                    description={
                        <FlexBox direction={DirectionEnum.COLUMN} gap={3}>
                            <InlinePrice
                                amount={funding.initialContributionWithOdr || funding.initialDeposit}
                                level={TextLevels.TWO}
                            />
                            <Text level={TextLevels.TWO} marginless>
                                +&nbsp;
                                <InlinePrice amount={funding.monthlyAmount} level={TextLevels.TWO} /> par mois pendant{' '}
                                {funding.installments ?? 0} mois {hasInterest ? 'avec frais' : null}
                            </Text>
                            {!hasInterest && (
                                <div>
                                    <Tag
                                        variant={TagVariant.INFO}
                                        iconName={IconName.SUN_EURO}
                                        small
                                        label='Crédit 0% sans frais'
                                    />
                                </div>
                            )}
                        </FlexBox>
                    }
                    name='fundingInstallment'
                />
                {isSelected && <FundingDetailsBox funding={funding} />}
                {hasOdr && isSelected && (
                    <OdrInfos odrRefund={odrRefund} phonePriceWithOdrDeducted={phonePriceWithOdrDeducted} />
                )}
            </FlexBox>
        </FlexItem>
    );
}
